import React, { useState, useEffect } from 'react';
import LoadFromLocalStorage from 'components/layout/options/LoadFromLocalStorage.jsx'
import { HandleActivationFormula, HandleOptionsUserChanged } from 'components/layout_and_quote_builder/options/drawing_options/index.js';

// Dropdown of admin-authored choices. The <select> value is a string token
// (option.select_choices[].value); the customer sees the localized description.
// A choice can carry its own activation_formula; the visible subset is
// recomputed server-side on redraw and pushed back via HandleActivationFormula.
const Select = ({ item, option, value, onChange, enabled, doNotLoadFromLocalStorage }) => {
  const updateOptionsUserChanged = () => { HandleOptionsUserChanged().add(option.name) };
  const [active, setActive] = useState(true);
  const [weRecommend, setWeRecommend] = useState('');
  const [visibleChoices, setVisibleChoices] = useState(option.select_choices || []);

  useEffect(() => {
    if(enabled) {
      document.dispatchEvent(new CustomEvent('REDRAW_REQUESTED', { "detail": item.uuid }));
    }
  }, [value]);

  useEffect(() => {
    if(doNotLoadFromLocalStorage) { return; }
    LoadFromLocalStorage(item, option.name, onChange)
  }, []);

  const attachEvents = () => {
    if (option.has_activation_formula || option.has_value_formula) {
      HandleActivationFormula({
        option: option,
        item: item,
        setActive: setActive,
        setWeRecommend: setWeRecommend,
        setVisibleChoices: setVisibleChoices,
      });
    }
  }

  useEffect(attachEvents, [enabled, item]);

  // A live update can hide the current choice; fall back to the first visible one.
  useEffect(() => {
    if (visibleChoices.length === 0) { return; }
    if (!visibleChoices.some((choice) => choice.value === value)) {
      onChange(visibleChoices[0].value);
    }
  }, [visibleChoices, value]);

  if(!active) { return null; }

  return (
    <div className="LayoutRedrawFormInputRow">
      <div className="input-group short-text">
        <span className="input-group-addon">
          {option.description}
        </span>

        <select
          name={option.name}
          value={value}
          onChange={ e => onChange(e.target.value)}
          onClick={updateOptionsUserChanged}
          className="form-control-int form-control selectpickerl"
        >
          {visibleChoices.map((choice) => <option key={choice.value} value={choice.value}> {choice.description} </option>)}
        </select>
      </div>
    </div>
  )
}

export default Select
